import { Client, Databases, RealtimeResponseEvent } from "appwrite";
import { appwriteConfig } from "@/lib/appwrite/config";
import { ID } from "appwrite";

type NotificationType = "message" | "deal" | "like" | "payment" | "system" | "error" | "follow" | "post" | "live_stream" | "violation" | "dispute" | "video_like" | "video_tip";

interface NotificationPayload {
    title: string;
    body: string;
    type: NotificationType;
    recipient_id: string;
    sender_id: string;
  }

class NotificationService {
  private client: Client;
  private databases: Databases;

  constructor() {
    this.client = new Client()
      .setEndpoint(appwriteConfig.url)
      .setProject(appwriteConfig.projectId);
    this.databases = new Databases(this.client);
  }

  public async createNotification(payload: NotificationPayload) {
    try {
      // 1. Store in database
      await this.databases.createDocument(
        appwriteConfig.databaseId,
        appwriteConfig.notificationsCollectionId,
        ID.unique(),
        {
          ...payload,
          is_read: false,
          created_at: new Date().toISOString()
        }
      );

      // 2. Immediate UI feedback for sender
      this.showLocalNotification(payload.title, payload.body);
    } catch (error) {
      console.error("Notification error:", error);
    }
  }

  private async showLocalNotification(title: string, body: string) {
    try {
      // Sound feedback
      const audio = new Audio("/assets/sounds/notification.mp3");
      audio.play().catch(e => console.log("Sound blocked:", e));

      // Vibration
      if ("vibrate" in navigator) navigator.vibrate([200, 100, 200]);

      // Browser notification
      if (Notification.permission === "granted") {
        new Notification(title, { body, icon: "/logo.png" });
      }
    } catch (error) {
      console.error("Local notification error:", error);
    }
  }

  public listenForUserNotifications(
    userId: string,
) {
    return this.client.subscribe(
      `databases.${appwriteConfig.databaseId}.collections.${appwriteConfig.notificationsCollectionId}.documents`,
      (response: RealtimeResponseEvent<any>) => {
        if (response.payload.recipient_id === userId && !response.payload.is_read) {
          this.showLocalNotification(
            response.payload.title,
            response.payload.body
          );
        }
      }
    );
  }
}

export const notificationService = new NotificationService();
